import React, { useContext } from 'react'
import {
    Stack,
    Box,
    Typography,
} from '@mui/material'

import { ThemeContext } from '../../context/theme/context.js'
import Header from '../../utils/header.js'
import data from '../../data/experience.json'
import useCursorHandlers from '../../hooks/cursor_handlers.js'
import CustomDivider from '../../utils/divider.js'

const Experience = () => {
    const { state } = useContext(ThemeContext)
    const cursorHandlers = useCursorHandlers()

    return <Box>
        <Header
            color={state.color.primary}
            title='EXPERIENCE' />
        <Stack
            direction={{ xs: 'column' }}
            width="100%"
            spacing={{ xs: 1, sm: 2, md: 4 }}
            alignItems="flex-start">
            {data.experience.map((item, index) =>
                <Stack
                    key={index}
                    direction={{ xs: 'column' }}
                    width="100%"
                    position="relative">
                    <Stack
                        direction={{ xs: 'row' }}
                        width="fit-content"
                        p="2% 0%"
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        {...cursorHandlers}>
                        <Typography
                            width="fit-content"
                            color={state.color.primary}
                            fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                            sx={{
                                fontSize: { xs: 24, md: 36 },
                                fontWeight: 900,
                                // textAlign: 'center',
                                // textTransform: 'uppercase',
                                // '&:hover': {
                                //     color: state.color.primary
                                // }
                            }}
                        >
                            {item.date}
                        </Typography>
                        <Stack
                            direction={{ xs: 'column' }}
                            width="fit-content"
                            spacing={{ xs: 1 }}
                            alignItems="flex-start"
                            justifyContent="center">
                            <Typography
                                color={state.color.primary}
                                fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                                sx={{
                                    fontSize: { xs: 24, md: 36 },
                                    fontWeight: 900,
                                    // textAlign: 'center',
                                    // textTransform: 'uppercase',
                                    // '&:hover': {
                                    //     color: state.color.primary
                                    // }
                                }}>
                                {item.company}
                            </Typography>
                            <Typography
                                color={state.color.primary}
                                fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                                width="fit-content"
                                sx={{
                                    fontSize: { xs: 14, md: 24 },
                                    fontWeight: 100,
                                    // textAlign: 'center',
                                    // textTransform: 'uppercase',
                                    // '&:hover': {
                                    //     color: state.color.primary
                                    // }
                                }}>
                                {item.title}
                            </Typography>
                            <Typography
                                color={state.color.primary}
                                fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                                width="fit-content"
                                sx={{
                                    fontSize: { xs: 11, md: 16 },
                                    fontWeight: 700,
                                    // textAlign: 'center',
                                    // textTransform: 'uppercase',
                                    // '&:hover': {
                                    //     color: state.color.primary
                                    // }
                                }}>
                                {item.description}
                            </Typography>
                        </Stack>
                    </Stack>
                    <CustomDivider />
                </Stack>
            )}
        </Stack >
    </Box >
}

export default Experience